import React, { ReactElement } from 'react'
import { CurrencyCode } from '../../types/API'
import {
  GiftItemStatus,
  IAddToBasket,
  IColorTheme,
  IGiftItemResponse,
  SelectedPrice,
} from '../../types/itemTypes'
import { StateAction } from '../../types/typeAliases'
import { Buttons } from './ItemButtonStyles'
import ItemPurchaseButtons from './ItemPurchaseButtons'
import SecondaryButton from './SecondaryButton'
import ShowPricesButton from './ShowPricesButton'

export interface IItemButtonsProps extends IAddToBasket {
  giftItem: IGiftItemResponse
  currency: CurrencyCode
  showDetails: boolean
  setShowDetails: StateAction<boolean>
  colorTheme: IColorTheme
  individuals: number
  soldOut: boolean
  showQuantity: boolean
  showPrices: boolean
  setShowPrices: StateAction<boolean>
  buyPrices: () => void
  resetPricesSelected: () => void
  pricesSelected: SelectedPrice[]
}
export default function ItemButtons({
  giftItem,
  currency,
  showDetails,
  setShowDetails,
  addToBasket,
  colorTheme,
  individuals,
  soldOut,
  showQuantity,
  showPrices,
  setShowPrices,
  buyPrices,
  resetPricesSelected,
  pricesSelected,
}: IItemButtonsProps): ReactElement {
  const { value } = giftItem

  const hasPrices = giftItem.prices && giftItem.prices.length > 0
  const soldOutOrInvalid = soldOut || (!hasPrices && !value)

  const activePrices = giftItem.prices
    && [...giftItem.prices].filter(
      ({ status }) => status === GiftItemStatus.Published,
    )

  const noActivePrices = !activePrices || activePrices.length === 0

  return (
    <Buttons>
      {showPrices ? (
        <SecondaryButton
          isActive={true}
          colorTheme={colorTheme}
          label="Close"
          onClick={(): void => {
            setShowPrices((p) => {
              if (p) resetPricesSelected()
              return !p
            })
          }}
        />
      ) : (
        <SecondaryButton
          isActive={showDetails}
          colorTheme={colorTheme}
          label="Details"
          onClick={(): void => setShowDetails((p) => !p)}
        />
      )}
      {!hasPrices && (
        <ItemPurchaseButtons
          giftItem={giftItem}
          currency={currency}
          addToBasket={addToBasket}
          colorTheme={colorTheme}
          individuals={individuals}
          soldOut={soldOut}
          showQuantity={showQuantity}
        />
      )}
      {hasPrices && (
        <ShowPricesButton
          soldOutOrInvalid={soldOutOrInvalid}
          colorTheme={colorTheme}
          showPrices={showPrices}
          setShowPrices={setShowPrices}
          showDetails={showDetails}
          buyPrices={buyPrices}
          resetPricesSelected={resetPricesSelected}
          pricesSelected={pricesSelected}
          noActivePrices={noActivePrices}
        />
      )}
    </Buttons>
  )
}
